import { DateTime } from 'luxon';
import { pruneSalesPersons } from '@/lib/serializerUtils';

export default (record) => {
  record = pruneSalesPersons(record);
  if (record.edisent) record.edisent = DateTime.fromSQL(record.edisent).toSQL({ includeOffset: false });
  return record;
};
